// src/admin/services/tagService.js

import api from "../../services/api";

export const tagService = {

  async getTags(search = "") {
      const response = await api.get(
          "/blog/admin/tags/",
          {
              params: { search },
          }
      );

      return response.data;
  },
  async createTag(data) {

    const response = await api.post(
      "/blog/admin/tags/",
      data
    );

    return response.data;
  },

  async updateTag(id, data) {

    const response = await api.patch(
      `/blog/admin/tags/${id}/`,
      data
    );

    return response.data;
  },

  async deleteTag(id) {

    const response = await api.delete(
      `/blog/admin/tags/${id}/`
    );

    return response.data;
  },
};